/* eslint-disable prettier/prettier */
import Result, { EmptyResult } from '../Result';

export class Record {
  public constructor(public readonly key: string, public readonly value: string, public readonly permanent: boolean) { }
}

export interface Storage {
  put(record: Record): Promise<Result>;
  delete(key: string): Promise<Result>;
  get(key: string): Promise<Result<string | null>>;
  getName(): string;
}

export default class LocalStorage implements Storage {
  public constructor() { }

  public getName(): string {
    return 'LocalStorage';
  }

  public async put({ key, value, permanent }: Record): Promise<Result> {
    if (permanent) {
      localStorage.setItem(key, value);
    }

    return new EmptyResult();
  }

  public async delete(key: string): Promise<Result> {
    localStorage.removeItem(key);

    return new EmptyResult();
  }

  public async get(key: string): Promise<Result<string | null>> {
    const value = localStorage.getItem(key);

    return new Result(value);
  }
}

export class SessionStorage implements Storage {
  public constructor() { }

  public getName(): string {
    return 'SessionStorage';
  }

  public async put({ key, value, permanent }: Record): Promise<Result> {
    if (!permanent) {
      sessionStorage.setItem(key, value);
    }

    return new EmptyResult();
  }

  public async delete(key: string): Promise<Result> {
    sessionStorage.removeItem(key);

    return new EmptyResult();
  }

  public async get(key: string): Promise<Result<string | null>> {
    const value = sessionStorage.getItem(key);

    return new Result(value);
  }
}
